import React, { useEffect, useState } from 'react';
import { IAutocompleteField, IField, ITextField } from '../../shared/interfaces';
import CircleLoader from '../Loader/CircleLoader/CircleLoader';
import { IBasePicker, IBasePickerSuggestionsProps, ITag, Label, mergeStyleSets, TagPicker, IMessageBarProps, MessageBarType, ScrollablePane } from '@fluentui/react';
import { reduxActions, RootState } from '../../store';
import { useSelector } from 'react-redux';
import DynamicForm from '../DynamicForm/DynamicForm';
import indicePAService from '../../services/indicePA.service';
import { store } from '../..';
import { useBoolean } from '@fluentui/react-hooks';
import { error } from 'console';


const classNames = mergeStyleSets({
    scrollablePaneWrapper: {
        position: 'relative',
        height: '100%',
    },

    inputWrapper:
    {
        paddingBottom: '20px',

    }
});

const initialFields: IField[] = [
    {
        displayName: "Ricerca per denominazione o acronimo",
        internalName: "searchValue",
        sharepointType: "",
        controlType: "autocomplete",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: [],
        valid: false,
        touched: false,
        multi: false,
    } as IAutocompleteField,
    {
        displayName: "Codice IPA",
        internalName: "codiceIPA",
        sharepointType: "Text",
        controlType: "textbox",
        required: false,
        readonly: true,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        showCopyButton: true
    } as ITextField,
    {
        displayName: "Denominazione",
        internalName: "denominazione",
        sharepointType: "Text",
        controlType: "textbox",
        required: false,
        readonly: true,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        showCopyButton: true
    } as ITextField,
    {
        displayName: "Acronimo",
        internalName: "acronimo",
        sharepointType: "Text",
        controlType: "textbox",
        required: false,
        readonly: true,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        showCopyButton: true
    } as ITextField,

];


export interface IndicePAFormProps {
    extraCssClass?: string
    onError: (errorMessageProps: IMessageBarProps) => void
}




const IndicePAForm: React.FunctionComponent<IndicePAFormProps> = (props) => {


    let [loading, { setTrue: showLoader, setFalse: hideLoader }] = useBoolean(false);

    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);

    const selectIndicePAFormFields = (state: RootState) => state.sessionReducer.indicePAFormFields;
    const indicePAFormFields = useSelector(selectIndicePAFormFields);


    useEffect(() => {
        const updatedFields = [...indicePAFormFields];
        if (updatedFields.length == 0) {
            let initFields = resetFormFields();
            store.dispatch(reduxActions.sessionActions.updateSession({ indicePAFormFields: initFields }));
        }
    }, []);

    const resetFormFields = (): IField[] => {
        let updatedFields = [...initialFields];
        let itemIndex = updatedFields.findIndex(el => el.internalName === 'searchValue');
        let searchValueField = { ...updatedFields[itemIndex] } as IAutocompleteField;
        searchValueField.searchAutocompleteSuggestions = searchAutocompleteSuggestions;

        updatedFields[itemIndex] = { ...searchValueField };
        return [...updatedFields]
    }

    const searchAutocompleteSuggestions = async (searchValue: string): Promise<ITag[]> => {
        let result: ITag[] = [];

        if (currentAoo && searchValue) {
            await indicePAService.searchEntePA(currentAoo.id, searchValue)
                .then(suggestions => {
                    result = suggestions.map(el => {
                        let tag: ITag = {
                            name: el.denominazione,
                            key: el.codiceIPA,
                        }
                        return tag;
                    });
                }, error => {

                    let errorMessageProps: IMessageBarProps = {
                        //truncated: true,
                        isMultiline: false,
                        overflowButtonAriaLabel: "See more",
                        dismissButtonAriaLabel: "Close",
                        messageBarType: MessageBarType.error,
                        children: `Errore nella ricerca dell'ente PA`,

                    };
                    props.onError(errorMessageProps);

                });
        }

        return result;

    }

    const getEntePA = (updatedFields: IField[], codiceIPA: string) => {

        if (currentAoo && codiceIPA) {
            showLoader();
            indicePAService.getEntePA(currentAoo.id, codiceIPA)
                .then(entePA => {

                    Object.keys(entePA).forEach(key => {
                        if (key == 'indirizziMail') {
                            entePA.indirizziMail.forEach((el, index) => {
                                updatedFields.push({
                                    displayName: "Indirizzo email",
                                    internalName: "indirizzo" + (index + 1),
                                    sharepointType: "Text",
                                    controlType: "textbox",
                                    required: false,
                                    readonly: true,
                                    disabled: false,
                                    system: false,
                                    internalValue: el,
                                    valid: false,
                                    touched: false,
                                    showCopyButton: true

                                });
                            })
                        }
                        else {
                            let itemIndex = updatedFields.findIndex(el => el.internalName === key);
                            if (itemIndex >= 0) {
                                let newfield = { ...updatedFields[itemIndex] };
                                newfield.internalValue = entePA[key].toString();
                                updatedFields[itemIndex] = { ...newfield }
                            }
                        }
                    });
                    store.dispatch(reduxActions.sessionActions.updateSession({ indicePAFormFields: updatedFields }));
                    hideLoader();
                }, error => {

                    let errorMessageProps: IMessageBarProps = {
                        //truncated: true,
                        isMultiline: false,
                        overflowButtonAriaLabel: "See more",
                        dismissButtonAriaLabel: "Close",
                        messageBarType: MessageBarType.error,
                        children: `Errore nella ricerca dell'ente PA`,

                    };
                    props.onError(errorMessageProps);

                });
        }

    }

    const onInputChangedHandler = (updatedField: IField) => {


        if (updatedField.internalName == 'searchValue') {
            /// se cambio l'ente selezionato faccio il reset della form
            let updatedFields = resetFormFields();
            let itemIndex = updatedFields.findIndex(el => el.internalName === updatedField.internalName);
            updatedFields[itemIndex] = { ...updatedField };

            if (updatedField.internalValue[0]?.key) {
                /// se ho selezionato un ente chiamo il metodo che restituisce le informazioni dell'ente e setta i nuovi valori della form
                getEntePA(updatedFields, updatedField.internalValue[0]?.key);
            }
            else {
                /// se invece rimuovo la selezione setto la form con gli initial fields
                store.dispatch(reduxActions.sessionActions.updateSession({ indicePAFormFields: updatedFields }));
            }
        } else {
            let updatedFields = [...indicePAFormFields];
            let itemIndex = updatedFields.findIndex(el => el.internalName === updatedField.internalName);
            updatedFields[itemIndex] = { ...updatedField };
            store.dispatch(reduxActions.sessionActions.updateSession({ indicePAFormFields: updatedFields }))

        }

    }


    return (
        <React.Fragment>

            <CircleLoader loaderClass='loader-large' loading={loading} />

            <div className={"flex flex-column position-relative overflow-hidden"}>

                <div className={`position-relative my-scroll-div`}>
                    <DynamicForm
                        fields={indicePAFormFields}
                        onInputChangedHandler={(updatedField) => { onInputChangedHandler(updatedField) }}
                    />
                </div>
            </div>

        </React.Fragment>
    );
}

export default IndicePAForm;



